import { render, staticRenderFns } from "./RepoItem.vue?vue&type=template&id=3c6ad537&scoped=true"
import script from "./RepoItem.vue?vue&type=script&lang=js"
export * from "./RepoItem.vue?vue&type=script&lang=js"
import style0 from "./RepoItem.vue?vue&type=style&index=0&id=3c6ad537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ad537",
  null
  
)

export default component.exports